import { ERegionType, ERoomType } from '@/editor/data/type';

/** Editor相关 */
export const HEIGHT_HEADER = 56;
export const LEFT_PANEL_ELEMENT_ID = 'slidar-panel';
export const LEFT_PANEL_OVERLAY_ID = 'slidar-panel-overlay';

/** 方案相关 */
export const AUTO_SAVE_INTERVAL = 10 * 60 * 1000; // 10分钟
export const DEFAULT_SCHEME_NAME = '名称未設定';

/** Google reCAPTCHA 网站密钥 */
export const GRECAPTCHA_SITE_KEY = import.meta.env.PUBLIC_RECAPTCHA_V2_SITE_KEY;

/** 用户相关 */
export const MAIL_VALIDATE_REG = new RegExp(/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/);
export const PASSWORD_VALIDATE_REG = new RegExp(/^(?=.*[a-zA-Z])(?=.*\d)[a-zA-Z0-9]{6,20}$/); // 6-20个字符，有且只有数字和英文字母
export const EMAIL_CODE_VALIDATE_REG = new RegExp(/^[a-zA-Z0-9]{6}$/);
export const USER_NAME_ALLOW_MAX_LENGTH = 20;
export const USER_EMAIL_ALLOW_MAX_LENGTH = 100;
export const USER_PASSWORD_ALLOW_MAX_LENGTH = 20;
export const USER_EMAIL_CODE_LENGTH = 6;
export const RE_SEND_EMAIL_CODE_COUNT_DOWN = 60;

/** Toast 通知 ID */
export const enum EToastId {
  GEN_LAYOUT_NETWORK_ERROR = 'layout-generate-network-error',
  GEN_LAYOUT_FAILED = 'layout-generate-failed'
}

/** 家具分类-全部 */
export const FURNITURE_CATEGORY_ALL_VALUE = '__ALL_FURNITURE_CATEGORIES__';

/** 左侧栏宽度 */
export enum ELeftPanelWidth {
  DEFAULT = 280,
  FURNITURE_LIBRARY = 324
}

export const LAYOUT_ALLOWED_REGION_TYPE: Array<ERegionType | ERoomType> = [
  ERegionType.Workspace,
  ERegionType.RestArea,
  ERegionType.DiscussionForum
] as const;

// 家具模型类型顺序
export const FURNITURE_MODEL_TYPES_ORDER = [
  'component.class.two.table',
  'component.class.two.chair',
  'component.class.two.sofa',
  'component.class.two.rack',
  'component.class.two.workshop',
  'component.class.two.tea',
  'component.class.two.officeDevice',
  'component.class.two.device',
  'component.class.two.plant'
];

/** 文件管理相关 */

export enum SCHEME_LOAD_ERROR {
  conflict = 'conflict'
}

export const DEFAULT_PAGE_SIZE = 24;
export const SCHEME_NAME_MAX_LENGTH = 50;
/** 根目录文件夹ID */
export const ROOT_FOLDER_ID = 0;
/** 文件夹深度限制 */
export const MAX_FOLDER_DEEP = 5;
export const CREATE_SCHEME_STORAGE_KEY = 'create_scheme_params';
export const SCHEME_LOAD_ERROR_STORAGE_KEY = 's_l_reason';
